
export enum ScreenNameEnum {
    StoreTransferRequest = 0,
    StoreTransferOrder,
    StoreTransferAccept,
    OutVoucher,
    InVoucher,
    SalesPriceList,
    SellOrder,
    Selldeliveryorder,
    Document,
    BuyDeliveryRequest,
    BuyOrder,
    BuyDeliveryOrder,
    PurchaseInvoice,
    StoreTransfer,
    InnerInVoucher,
    InnerOutVoucher,
    ReturnDocument,
    OldReturnDocument,
    ReturnPurchaseInvoice,
    OldReturnPurchaseInvoice,
    salaryVoca,
    salaryVocaActions,
    allShowSalary,
    PatientDocument,
    PatientReturnDocument,
    PatientOutVoucher,
    EmployeeAll,
    BuyPriceList,
    ProductionLineJobOrder,
    ConstructionOutVoucher,
    DirectProductionLineJobOrder


}